<template>
  <div id="userLoginView">
    <h2 style="margin-bottom: 16px">用户登录</h2>
    <a-form
      style="max-width: 480px; margin: 0 auto"
      label-align="left"
      auto-label-width
      :model="form"
      @submit="handleSubmit"
    >
      <a-form-item field="userAccount" label="账号">
        <a-input v-model="form.userAccount" placeholder="请输入账号" />
      </a-form-item>
      <a-form-item field="userPassword" tooltip="密码不少于 8 位" label="密码">
        <a-input-password
          v-model="form.userPassword"
          placeholder="请输入你的密码"
        />
      </a-form-item>
      <div
        style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        "
      >
        <a-button type="primary" html-type="submit" style="width: 120px"
          >登录</a-button
        >
        <a-link href="/user/register">新用户注册</a-link>
      </div>
    </a-form>
  </div>
</template>

<script setup lang="ts">
import { userLoginUsingPost } from "@/api/userController";
import message from "@arco-design/web-vue/es/message";
import { useLoginUserStore } from "@/store/useStore";
import { useRouter } from "vue-router";
import { reactive } from "vue";
import API from "@/api";

const router = useRouter();
const loginUserStore = useLoginUserStore();

const form = reactive({
  userAccount: "",
  userPassword: "",
} as API.UserLoginRequest);

/**
 * 提交表单
 * @param data
 */
const handleSubmit = async () => {
  const res = await userLoginUsingPost(form);
  // 登录成功，跳转：
  if (res.data.code === 0) {
    await loginUserStore.fetchLoginUser();
    message.success("登录成功");
    router.push({
      path: "/",
      replace: true,
    });
  } else {
    message.error("登录失败，" + res.data.message);
  }
};
</script>

<style scoped></style>
